import { Component, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { SupportContactDialogComponent } from 'src/app/shared/support-contact-dialog/support-contact-dialog.component';
import { Organization, Profile } from '../user.service';

@Component({
  selector: 'app-organizations',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './organizations.component.html',
  styleUrl: './organizations.component.scss',
})
export class OrganizationsComponent {
  #router = inject(Router);
  #dialog = inject(MatDialog);

  profile = input<Profile>();
  selected = output<Organization>();
  logout = output();
  close = output();

  canSwitchOrgs(): boolean {
    return (this.profile()?.organizations?.length ?? 0) > 1;
  }

  onOrganizationSelected(o: Organization) {
    if (!this.canSwitchOrgs()) {
      return;
    }
    this.selected.emit(o);
  }

  onClose() {
    this.close.emit();
  }

  onLogout() {
    this.logout.emit();
  }

  onNavigateToDashboard(): void {
    void this.#router.navigate(['/contacts']);
    this.close.emit();
  }

  onNavigateToAlertRoster(): void {
    void this.#router.navigate(['/alert-roster']);
    this.close.emit();
  }

  onNavigateToUserManagement(): void {
    void this.#router.navigate(['/users']);
    this.close.emit();
  }

  onNavigateToAlertHistory(): void {
    void this.#router.navigate(['/alerts']);
    this.close.emit();
  }

  onNavigateToConfiguration(): void {
    void this.#router.navigate(['/configuration']);
    this.close.emit();
  }

  onContact(): void {
    this.close.emit();
    this.#dialog.open(SupportContactDialogComponent);
  }
}
